import _ from "lodash";

export default class Node {
  column;
  value;
  groups;
  next;
  image;

  constructor(nodeWire, columnById, groupByPageNumber, imageByNameLowerCase) {
    this.column = columnById[nodeWire.tile_node_dto_column_id];
    this.value = nodeWire.tile_node_dto_value;
    this.groups = nodeWire.tile_node_dto_page_ids.map(pageNumber => groupByPageNumber[pageNumber]);

    var imageNameLowerCase = nodeWire.tile_node_dto_image_name.toLowerCase();
    this.image = imageByNameLowerCase[imageNameLowerCase] || imageByNameLowerCase["amptab_default.jpg"];

    if (!nodeWire.tile_node_dto_children || nodeWire.tile_node_dto_children.length == 0) {
      return;
    }

    var children = nodeWire.tile_node_dto_children.map(nodeWire => new Node(nodeWire, columnById, groupByPageNumber, imageByNameLowerCase));
    this.next = _.keyBy(children, child => child.value);
  }

  filter(columnIdToValues) {
    return this.groups.filter(group => group.filter(columnIdToValues));
  }
}